import React, { useEffect, useState } from 'react'
import FinesYesView from './components/FinesYesView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const FinesYes = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('fines-yes', 'Pay a Fee for Defaulted Fines', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <FinesYesView setIsError={setIsError} />
}

export default withTranslation('common')(FinesYes)
